import deepPurple from 'material-ui-next/colors/deepPurple';

// MUI Color Variables
const deepPurple500 = deepPurple['500'];
const deepPurple700 = deepPurple['700'];

export default {
  palette: {
    primary1Color: deepPurple500,
    primary2Color: deepPurple700,
  },
  datePicker: {
      headerColor: deepPurple500,
  },
};



/** WEBPACK FOOTER **
 ** ./src/dashboard/theme.js
 **/